import styled from 'styled-components'

export const SelectCourseStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 15px 0 0 0;
  width: 100%;

  label {
    color: ${({ theme }) => {
      return theme.colors.darkPrimary
    }};
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin
    }};
    margin: 0 0 10px 0;
  }

  div {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
  }
`
